import axios from "axios";
import config from "../config";
import authHeader from "./auth-header";
import { buildContentReferenceViewRequest } from "./contentContract";

const view = (values = {}) => {
  const request = buildContentReferenceViewRequest(
    "afterlogin/everydaymarketingcategory/view",
    values,
    { defaultLimit: 30 },
  );
  return axios.post(`${config.API_URL}${request.url}`, request.body, { headers: authHeader() });
};

export default { view };
